/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.type = 'text/css';
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

function _DynamicStyleSheet(options) {
  this.ctr = 0;
  this.opts = options;
}

function _inject() {
  if (process.env.NODE_ENV !== 'production' && this.tag !== undefined) {
    throw new Error('This stylesheet has already been injected');
  }

  this.tag = makeStyleTag(this.opts);
  this.sheet = sheetForTag(this.tag);
}

function _insertRules(rules) {
  this.removeRules();
  rules.forEach(this.insert, this);
}

function _insert(rule) {
  try {
    this.sheet.insertRule(rule, this.ctr);
    this.ctr++;
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn("Invalid Rule: \"" + rule + "\"", e);
    }
  }
}

function _removeRules() {
  if (this.ctr !== 0) {
    while (this.ctr--) {
      this.sheet.deleteRule(this.ctr);
    }

    this.ctr = 0;
  }
}

function _flush() {
  // $FlowFixMe
  this.tag.parentNode.removeChild(this.tag);
  this.ctr = 0; // $FlowFixMe

  this.tag = undefined; // $FlowFixMe

  this.sheet = undefined;
}

var DynamicStyleSheet =
/*#__PURE__*/
function () {
  var _proto = _DynamicStyleSheet.prototype;
  _proto.inject = _inject;
  _proto.insertRules = _insertRules;
  _proto.insert = _insert;
  _proto.removeRules = _removeRules;
  _proto.flush = _flush;
  return _DynamicStyleSheet;
}();

function _StyleSheet(options) {
  this.isSpeedy = process.env.NODE_ENV === 'production'; // the big drawback here is that the css won't be editable in devtools

  this.tags = [];
  this.ctr = 0;
  this.opts = options;
}

function _inject2() {
  if (this.injected) {
    throw new Error('already injected!');
  }

  if (this.isSpeedy) {
    this.tags[0] = makeStyleTag(this.opts);
  }

  this.injected = true;
}

function _speedy(bool) {
  if (this.ctr !== 0) {
    // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
    throw new Error("cannot change speedy now");
  }

  this.isSpeedy = !!bool;
}

function _insert2(rule, sourceMap) {
  // this is the ultrafast version, works across browsers
  if (this.isSpeedy) {
    var tag = this.tags[this.tags.length - 1];
    var sheet = sheetForTag(tag);

    try {
      sheet.insertRule(rule, sheet.cssRules.length);
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('illegal rule', rule); // eslint-disable-line no-console
      }
    }
  } else {
    var _tag = makeStyleTag(this.opts);

    this.tags.push(_tag);

    _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
  }

  this.ctr++;

  if (this.ctr % 65000 === 0) {
    this.tags.push(makeStyleTag(this.opts));
  }
}

function _ref(tag) {
  return tag.parentNode.removeChild(tag);
}

function _flush2() {
  // $FlowFixMe
  this.tags.forEach(_ref);
  this.tags = [];
  this.ctr = 0; // todo - look for remnants in document.styleSheets

  this.injected = false;
}

var StyleSheet =
/*#__PURE__*/
function () {
  var _proto2 = _StyleSheet.prototype;
  _proto2.inject = _inject2;
  _proto2.speedy = _speedy;
  _proto2.insert = _insert2;
  _proto2.flush = _flush2;
  return _StyleSheet;
}();

export { DynamicStyleSheet, StyleSheet };
//# sourceMappingURL=index.es.js.map



// WEBPACK FOOTER //
// ./node_modules/@emotion/sheet/dist/index.es.js